var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJanssen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "107.5px",
    height: "145.3px",
    viewBox: "0 0 107.5 145.3",
    enableBackground: "new 0 0 107.5 145.3",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#CCCCCC",
    d: "M76.142,31.029c0,0-13.606,2.603-35.517-0.716C21.052,27.341,2.785,14.44,1,2.536 c0,0,7.93,10.8,38.516,15.426c0,0,10.1,1.45,24.442,1.51C73.021,19.516,76.142,31.029,76.142,31.029z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "M102.188,40.413c-12.913-0.235-59.737-1.784-59.737-1.784c4.385,6.897,8.912,18.728,8.912,32.072 c0,32.455-14.161,56.383-32.466,72.487c30.911-6.49,54.568-40.643,54.568-77.396c0.032-2.993-0.022-6.014-0.148-8.679l23.893-8.156 c3.022-1.054,4.95-2.701,4.962-5.586C102.183,41.418,102.188,40.413,102.188,40.413z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJanssen);
export default __webpack_public_path__ + "static/media/janssen.982bfa48198987e1b266a3d399500e5a.svg";
export { ForwardRef as ReactComponent };